import React from "react";
import styled from "styled-components";

const Icon = styled.div`
  height: 18px;
  width: 18px;
  @media (min-width: 1800px) {
    height: 27.53px;
    width: 27.53px;
  }
`;

const SunIcon = () => {
  return (
    <Icon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100%"
        width="100%"
        viewBox="0 0 27.53 27.53"
      >
        <circle
          cx="8.259"
          cy="8.259"
          r="8.259"
          transform="translate(5.506 5.506)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          y1="6.424"
          transform="translate(13.765)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          y1="4.542"
          x2="4.542"
          transform="translate(18.959 4.029)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x2="6.424"
          transform="translate(21.106 13.765)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x2="4.542"
          y2="4.542"
          transform="translate(18.959 18.959)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          y2="6.424"
          transform="translate(13.765 21.106)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="4.542"
          y2="4.542"
          transform="translate(4.029 18.959)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="6.424"
          transform="translate(0 13.765)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="4.542"
          y1="4.542"
          transform="translate(4.029 4.029)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    </Icon>
  );
};

export default SunIcon;
